import React, { Component } from 'react';

import { SearchProvider } from 'context/SearchContext';
import { SearchFormProvider } from 'context/SearchFormContext';
import { ProductProvider } from 'context/ProductContext';
import { StaticTextProvider } from 'context/StaticTextContext';
import { CountryProvider } from 'context/CountryContext';
import { WindowSizeContextProvider } from 'context/WindowSizeContext';

import Routes from './Routes';
import './App.module.scss';

class App extends Component {
  render() {
    return (
      <WindowSizeContextProvider>
        <StaticTextProvider>
          <CountryProvider>
            <SearchProvider>
              <ProductProvider>
                <SearchFormProvider>
                  <Routes />
                </SearchFormProvider>
              </ProductProvider>
            </SearchProvider>
          </CountryProvider>
        </StaticTextProvider>
      </WindowSizeContextProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js